module.exports = __webpack_public_path__ + "img/国防科技大学研究生院.12f880c7.png";